import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const KRAUrl = `${Base_Url}/KRA`;

export const GetKRAList = async (params) => {
  const res = await postApiWithAuthorization(`${KRAUrl}/GetKRAList`, params);
  return res;
};

export const AddUpdateKRA = async (params) => {
  const res = await postApiWithAuthorization(
    `${KRAUrl}/AddUpdateKRA?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetKRAModel = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${KRAUrl}/GetKRAModel?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&KRAKeyID=${KeyID}`
  );
  return res;
};

export const ChangeKRAStatus = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${KRAUrl}/ChangeKRAStatus?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&KRAKeyID=${KeyID}`
  );
  return res;
};

// export const DeleteLeaveType = async (ModuleName, KeyID, adminKeyID) => {
//   const res = await getApiWithAuthorization(
//     `${KRAUrl}/DeleteLeaveType?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&KRAKeyID=${KeyID}`
//   );
//   return res;
// };
